import React from 'react'
import IconChevronLeft from '@/components/IconChevronLeft'
import IconChevronRight from '@/components/IconChevronRight'
import { scrollButton } from './miniCarousel.module.css'

const ScrollButton = ({ onClick, left, right, smallArrow, className = '' }) => {
  const smallArrowClass = smallArrow ? 'w-[36px] h-[36px]' : 'w-[50px] h-[50px]'
  const size = smallArrow ? 'md' : 'lg'

  return (
    <div
      className={`${scrollButton} ${smallArrowClass} bg-white hover:bg-gray-400 ${className}`}
      onClick={() => onClick()}
    >
      {left && (
        <IconChevronLeft
          className="arrow"
          size={size}
        />
      )}
      {right && (
        <IconChevronRight
          className="arrow"
          size={size}
        />
      )}
    </div>
  )
}
export default ScrollButton
